import { useState } from 'react'
import { timeLabel, timePresets } from '../lib/timeRanges'
import { FilterPage } from './FilterPage'
import { Icon } from './Icon'

/** The When page Search and the audit log share: any time, a preset, or dates picked by hand ("2026-09-01", local days). */
export function TimeFilterPage({
  title,
  from,
  to,
  onPick,
  onClose,
}: {
  title: string
  from: string
  to: string
  onPick: (from: string, to: string) => void
  onClose: () => void
}) {
  const [pickingDates, setPickingDates] = useState(false)
  const [draftFrom, setDraftFrom] = useState(from)
  const [draftTo, setDraftTo] = useState(to)
  const preset = from && !to ? timePresets.find((p) => p.from(new Date()) === from) : undefined
  // Dates picked by hand rather than a preset: the Pick dates row is the choice, showing them.
  const custom = Boolean(from || to) && !preset
  return (
    <FilterPage
      title={title}
      options={[{ id: '', label: 'Any time' }, ...timePresets.map((p) => ({ id: p.id, label: p.label }))]}
      chosen={preset?.id ?? (custom ? 'dates' : '')}
      onPick={(id) => onPick(timePresets.find((p) => p.id === id)?.from(new Date()) ?? '', '')}
      onClose={onClose}
    >
      {pickingDates ? (
        <div className="filter-dates">
          <label>
            After
            <input type="date" className="text-input" value={draftFrom} onChange={(e) => setDraftFrom(e.target.value)} />
          </label>
          <label>
            Before
            <input type="date" className="text-input" value={draftTo} onChange={(e) => setDraftTo(e.target.value)} />
          </label>
          <button type="button" className="button primary" onClick={() => onPick(draftFrom, draftTo)}>
            Done
          </button>
        </div>
      ) : (
        <button type="button" className={custom ? 'filter-option is-chosen' : 'filter-option'} onClick={() => setPickingDates(true)}>
          <span>Pick dates</span>
          {custom ? (
            <>
              {' '}
              <small>{timeLabel(from, to)}</small>
            </>
          ) : null}
          <Icon name="chevronRight" />
        </button>
      )}
    </FilterPage>
  )
}
